export function extract(value, { formatter }) {
    if (!formatter)
        return {};
    const keys = Object.keys(formatter({}));
    return keys.reduce((data, key) => {
        if (value?.hasOwnProperty(key)) {
            ;
            data[key] = value[key];
        }
        return data;
    }, {});
}
//# sourceMappingURL=extract.js.map